<template>
	<div class="sp-template">
		<div class="h-title">服务类型管理</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item label="名称">
						<el-input v-model="conditions.name" placeholder="请输入名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(71201)" type="primary" @click="search">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(71202)" size="small" @click="add">添加</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" v-loading="loading" :data="serviceTypeData" stripe border style="width: 100%">
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="createAt" label="创建时间"></el-table-column>
				<el-table-column prop="operator" label="操作者"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope" >
						<el-button type="text" size="mini" v-if="in_configs(71203)" @click="edit(scope.$index, scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<el-dialog :title="title" :visible.sync="dialogFormVisible" class="fullwidth-form__dialog" width="500px">
				<el-form :model="serviceTypeForm" status-icon :rules="rules" ref="serviceTypeForm" size="small" label-width="80px">
          <el-form-item label="名称"  prop = "name">
						<el-input v-model="serviceTypeForm.name" auto-complete="off" placeholder="名称" style="width:300px" clearable></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
					<el-button size="small" type="primary" @click="submit('serviceTypeForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
export default {
  data() {
    return {
      title: "添加",
      conditions: {
        name: ""
      },
      serviceTypeData: [],
      serviceTypeForm: {
        id: "",
        name: ""
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      total: 1, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      loading: true
    };
  },
  created() {
    setTimeout(() => {
      this.loading = false;
      this.query();
    }, 1000);
  },
  methods: {
    //搜索
    search() {
      this.currentPage = 1;
      this.query();
    },
    //加载数据
    query() {
      this.$request1({
        method: 'GET',
        url: '/system/supplier-service-type',
        params: {
          name: this.conditions.name,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.serviceTypeData = response.data.data;
            this.total = response.data.total;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 添加
    add() {
      this.dialogFormVisible = true;
      this.title = "添加";
      this.serviceTypeForm.id = "";
      this.serviceTypeForm.name = "";
    },
    // 编辑
    edit(index, row) {
      this.dialogFormVisible = true;
      this.title = "编辑";
      this.serviceTypeForm.id = row.id;
      this.serviceTypeForm.name = row.name;
    },
    //添加/修改
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/system/supplier-service-type',
            data: this.serviceTypeForm
          })
            .then(response => {
              if (response.data.success) {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.dialogFormVisible = false;
                this.query();
              } else {
                this.$message.error(response.data.message);
              }
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //分页
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.query();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.query();
    }
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/servicetypemanage.vue